import styled,{css} from 'styled-components';

export default styled.a`
  margin-left: 20px;
  text-transform: none;
  font-size: 16px;
  color: red !important;
  border: solid red 1px;
  padding-left: 25px;
  padding-right: 25px;
  font-family: 'Poppins', sans-serif;
  border-radius: 6px;
  ${props =>
    props.gray &&
    css`
      background-color: #f7f7f7 !important;
    `}
`;
